<div class="content-layout">
  <bw-action-article-legacy>
    <div content-section>
      <bw-spinner-legacy brightsideWebTimeout *ngIf="processing"></bw-spinner-legacy>
    </div>

    <div footer-actions class="flex-row flex-item-flexible space-between"></div>
  </bw-action-article-legacy>
</div>
